import { Offer } from "../../stores/OfferStore/types";
import { Chip } from "@mui/material";
import { cityMap } from "../../utils/cityCodes";
import * as React from "react";

export const LawyerInfo = (offer: Offer, t: (key: string) => string) => (
  <>
    <h4 className="mb0">
      <div>
        <i className="fal fa-user-tie" style={{ fontSize: "24px" }}></i>
        <span>
          {offer.lawyer?.firstName} {offer.lawyer?.lastName}
        </span>
      </div>
      <Chip
        size={"small"}
        color={"info"}
        icon={
          <i className="fa fa-map-marker-alt" style={{ fontSize: "11px" }} />
        }
        label={offer.lawyer && cityMap[offer.city]}
      />
    </h4>
    <div className="subheader">
      <span className="mr">
        {t("bar-number")}: {offer.lawyer?.barNo}
      </span>
    </div>
  </>
);
